<template>
    <ac-modal :title="''" ref="modal" :size-class="'modal-md'">
        <template slot="header">
            <div class="row" v-if="widgetReady">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="box-icon-avatar">
                            <img class="box-icon-img" :src="vm.imageLink">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <h4 class="text-center">
                                {{vm.name}}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-6">
                        <div class="text-center">
                            <h5>Provider Information</h5>
                            <address>
                                <span v-if="hasAddress">
                                        {{vm.address}},&nbsp;
                                        <br/>
                                        {{vm.region}}&nbsp;{{vm.zipCode}}

                                </span>
                                <span v-else>
                                    <strong>Address not set</strong>
                                </span>
                                <br>
                                {{vm.providerPhoneNumber | phoneNumber}}
                            </address>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="text-center">
                            <h5>Primary Contact</h5>
                            {{vm.firstName}}&nbsp;{{vm.lastName}}<br/>
                            {{vm.emailAddress}}<br/>
                            {{vm.contactPhoneNumber | phoneNumber}}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {common} from "../../../../global/common.js";

    export default {
        name: "AffiliationInfoModal",
        data() {
            return {
                widgetReady: false,
                vm: {}
            }
        },
        computed: {
            hasAddress() {
                return this.widgetReady && this.hasValue(this.vm.addressId);
            }
        },
        methods: {
            async showModal({providerEntityId, requesteeOrRequestor, isSentRequest}) {
                let data = await api.get('Affiliation', providerEntityId, `GetAffiliationInfoModalViewModel/${requesteeOrRequestor}/${isSentRequest}`);
                let info = data[0];
                info.imageLink = common.generateImageLink(info.profilePictureId, common.IMAGE_SIZE.MEDIUM.id);
                this.mapData('vm', info);
                this.widgetReady = true;
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>

</style>